import { styled } from 'styled-components';

import { theme } from '../../styles';
import { Container } from '../Layout';

type FAQCenteredProps = {
  children: React.ReactNode;
};

const Children = styled.div`
  border-bottom: 1px solid ${theme.colors.lightGrey};
`;

export const FAQCentered = ({ children }: FAQCenteredProps) => (
  <Container maxWidth={578} marginLeft="auto" marginRight="auto">
    <Children>{children}</Children>
  </Container>
);
